import { useCallback, useEffect, useMemo, useState } from "react";

const useTextHeight = (containerRef: React.RefObject<HTMLAnchorElement>) => {
  const [height, setHeight] = useState(0);
  const [overflow, setOverflow] = useState(0);
  const [metrics, setMetrics] = useState<{ height: number, lines: number, lineHeight: number } | null>(null);
  const [annotationHeight, setAnnotationHeight] = useState(0);

  useEffect(() => {
    setOverflow((containerRef.current?.scrollHeight || 0) - (containerRef.current?.clientHeight || 0));
  }, []);

  const getMeasures = useCallback((metrics: { height: number, lines: number, lineHeight: number }) => {
    setMetrics(metrics);
  }, []);

  useEffect(() => {
    if (!!annotationHeight) return;
    const overflowingLines = Math.ceil(overflow / (metrics?.lineHeight || 0));
    setAnnotationHeight((metrics?.lines || 0) - overflowingLines);
  }, [metrics, overflow]);

  return { getMeasures, annotationHeight };
};

export default useTextHeight;import { useCallback, useEffect, useMemo, useState } from "react";

const useTextHeight = (containerRef: React.RefObject<HTMLAnchorElement>) => {
  const [height, setHeight] = useState(0);
  const [overflow, setOverflow] = useState(0);
  const [metrics, setMetrics] = useState<{ height: number, lines: number, lineHeight: number } | null>(null);
  const [annotationHeight, setAnnotationHeight] = useState(0);

  useEffect(() => {
    setOverflow((containerRef.current?.scrollHeight || 0) - (containerRef.current?.clientHeight || 0));
  }, []);

  const getMeasures = useCallback((metrics: { height: number, lines: number, lineHeight: number }) => {
    setMetrics(metrics);
  }, []);

  useEffect(() => {
    if (!!annotationHeight) return;
    const overflowingLines = Math.ceil(overflow / (metrics?.lineHeight || 0));
    setAnnotationHeight((metrics?.lines || 0) - overflowingLines);
  }, [metrics, overflow]);

  return { getMeasures, annotationHeight };
};

export default useTextHeight;